import React, {useState} from 'react'
import FetchUtil from "../util/FetchUtil";
import ConfigUtil from "../util/ConfigUtil";
import {NavLink} from "react-router-dom";
import {NAVIGATION_ITEM} from "../constants/navigationItems";
import ErrorInfoComponent from "./general/ErrorInfoComponent";
import DHDefaultDrawer from "./general/DHDefaultDrawer";
import DHButtonClose from "./general/DHButtonClose";
import DHTextField from "./general/DHTextField";
import DHPasswordField from "./general/DHPasswordField";
import DHSwitch from "./general/DHSwitch";
import DHButtonDefault from "./general/DHButtonDefault";
import HowToRegIcon from '@mui/icons-material/HowToReg';

export default function RegistrierenDialog({onClose}) {

    const [infoMessage, setInfoMessage] = useState(undefined);
    const [errorMessage, setErrorMessage] = useState(undefined);

    const [agb, setAgb] = useState(false);
    const [email, setEmail] = useState("");
    const [mobil, setMobil] = useState("");
    const [username, setUsername] = useState("");
    const [name, setName] = useState("");
    const [firstname, setFirstname] = useState("");
    const [password1, setPassword1] = useState("");
    const [password2, setPassword2] = useState("");
    const [saving, setSaving] = useState(false);


    const handelKeyDown = (e) => {
        if (e.keyCode === 13) {
            // enter
            save();
        }
    }

    const save = () => {
        setErrorMessage(undefined);

        let alleFelderGefuellt = checkInput();
        if (!alleFelderGefuellt) {
            return;
        }

        setSaving(true);
        let url = ConfigUtil.getConfig().resourceUrls.user + "/registration";
        let data = {
            email: email,
            username: username,
            name: name,
            mobil: mobil,
            firstname: firstname,
            password1: password1,
            password2: password2,
        };
        FetchUtil.fetchPost(url,
            data,
            message => {
                if( message) {
                    setErrorMessage(message);
                    setSaving(false);
                } else {
                    setInfoMessage("Bitte prüfe deine Mails (auch SPAM) und bestätige deine Registrierung innerhalb von 2 Stunden. Danach läuft deine Registrierung ab und du musst eventuell eine weitere Registrierung durchführen.");
                }
            },
            responseNotOk => {
                setErrorMessage("Fehler: " + responseNotOk.message);
                setSaving(false);
            },
            error => {
                setErrorMessage("Fehler: " + error.message);
                setSaving(false);
            }
        );
    }

    const checkInput = () => {
        let alleFelderGefuellt = name !== "" && firstname !== "" && username !== "" &&
            email !== "" && password1 !== "" && password2 !== "" && agb;
        return alleFelderGefuellt;
    }


    return <DHDefaultDrawer title="Registrierung" onClose={() => onClose()} show={true} children={<div style={{padding:20}}>
        <ErrorInfoComponent infoMessage={infoMessage} errorMessage={errorMessage} onClearInfoMessage={() => setInfoMessage(undefined)} onClearErrorMessage={() => setErrorMessage(undefined)}/>

        <div className="col-12 md:col-12 lg:col-8">
            <div className="grid">
                <div className="col-12 md:col-6 lg:col-12">
                    <DHTextField id="id-benutzername" disabled={false} label="Benutzername" required={true}
                                 value={username} onChange={(text) => setUsername(text)} width={"100%"}
                                 onKeyDown={(e) => handelKeyDown(e)}/>
                </div>
                <div className="col-12 md:col-6 lg:col-12">
                    <DHTextField id="id-vorname" disabled={false} label="Vorname" required={true}
                                 value={firstname} onChange={(text) => setFirstname(text)} width={"100%"}
                                 onKeyDown={(e) => handelKeyDown(e)}/>
                </div>
                <div className="col-12 md:col-6 lg:col-12">
                    <DHTextField id="id-name" disabled={false} label="Name" required={true}
                                 value={name} onChange={(text) => setName(text)} width={"100%"}
                                 onKeyDown={(e) => handelKeyDown(e)}/>
                </div>
                <div className="col-12 md:col-6 lg:col-12">
                    <DHTextField id="id-email" disabled={false} label="Email" required={true}
                                 value={email} onChange={(text) => setEmail(text)} width={"100%"}
                                 onKeyDown={(e) => handelKeyDown(e)}/>
                </div>
                <div className="col-12 md:col-6 lg:col-12">
                    <DHTextField id="id-mobil" disabled={false} label="Mobil" required={false}
                                 value={mobil} onChange={(text) => setMobil(text)} width={"100%"}
                                 onKeyDown={(e) => handelKeyDown(e)}/>
                    <div style={{fontSize:10, marginTop:5}}>
                        Sofern du dich mit dem Account bei Events anmelden möchtest, musst du deine Handynummer angeben.
                    </div>
                </div>
                <div className="col-12 md:col-6 lg:col-12">
                    <DHPasswordField id="id-password" disabled={false} label="Kennwort"
                                 value={password1} onChange={(text) => setPassword1(text)} width={"100%"}
                                 onKeyDown={(e) => handelKeyDown(e)}/>
                </div>
                <div className="col-12 md:col-6 lg:col-12">
                    <DHPasswordField id="id-password2" disabled={false} label="Kennwort wiederholung"
                                     value={password2} onChange={(text) => setPassword2(text)} width={"100%"}
                                     onKeyDown={(e) => handelKeyDown(e)}/>
                </div>
            </div>
        </div>
        <div className="col-12 md:col-12 lg:col-12">
            <div>
                Mit dem Klick auf "Registrieren" willige ich in die Verarbeitung meiner personenbezogenen Daten gemäß der
                <NavLink to={NAVIGATION_ITEM.DATENSCHUTZ.route} style={{textDecoration: "none"}}>
                    <span style={{marginLeft: 5, marginRight: 5}} onClick={() => onClose()}>Datenschutzerklärung</span>
                </NavLink>von darthelfer.de ein.
            </div>
            <DHSwitch id={"id-agb"} value={agb} onChange={() => setAgb(!agb)} label={<>
                Ich stimme der
                <NavLink to={NAVIGATION_ITEM.AGB.route} style={{textDecoration: "none"}}>
                    <span style={{marginLeft: 5, marginRight: 5}} onClick={() => onClose()}>AGB</span>
                </NavLink>
                von darthelfer.de zu.</>} disabled={false} required={false}/>
        </div>
        <div className="col-12 md:col-12 lg:col-12" style={{marginTop: 10}}>
            <div className="grid">
                <div className="col">
                    <DHButtonDefault label="Registrieren"
                                     icon={<HowToRegIcon/>}
                                     disabled={!checkInput() || saving} onClick={() => save()} style={{marginRight:5}} />
                    <DHButtonClose onClick={() => onClose()}/>
                </div>
            </div>
        </div>
    </div>}/>
}
